import { useMemo, useState } from 'react'
import MultiDeliveryCycleHttp from '../../../../../services/api/https/deliveries/multi-delivery-cycle.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'

const INITIAL_STATE = {
  loadingMessage: null,
  errorMessage: null,
  ciclos: [],
  clientesNaoCadastrados: [],
  produtosNaoCadastrados: [],
  rowsCaixaFracionadas: [],
  selectedTab: 0,
  showModalCliente: false,
  showModalProduto: false,
  selectedCliente: null,
  selectedProduto: null,
  successMessage: null,
}

const { id: userId } = getUsuarioInfo()

export default function useImportacaoMultiploCicloEntregas() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    let fileContent = null

    return {
      async getCiclosImportados(mCiclo) {
        setState(prev => ({ ...prev, loadingMessage: 'Obtendo os Ciclos Importados . . .' }))
        try {
          const ciclosImportados = await MultiDeliveryCycleHttp.getCiclosImportados(mCiclo.id)
          setState(prev => ({ ...prev, loadingMessage: null, ciclos: ciclosImportados }))
        } catch (e) {
          setState(prev => ({ ...prev, loadingMessage: null, errorMessage: errorHandler(e) }))
        }
      },

      async updateCicloEntregaDataOperacao(ciclos) {
        setState(prev => ({ ...prev, loadingMessage: 'Obtendo os Ciclos Importados . . .' }))
        try {
          const ciclosFiltered = ciclos.filter(c => c.data_operacao)
          if (ciclosFiltered.length === 0) {
            setState(prevState => ({
              ...prevState,
              loadingMessage: null,
              errorMessage: 'Insira pelo menos 1 data de operação para salvar.',
            }))
          } else {
            const ciclosIdWithDate = ciclosFiltered.map(c => {
              return {
                delivery_cycle_id: c.delivery_cycle_id,
                data_operacao: parseToMysqlFormat(new Date(c.data_operacao)),
              }
            })
            await MultiDeliveryCycleHttp.updateDataOperacao(ciclosIdWithDate)
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              successMessage: 'Data(s) de Operação salva(s) com sucesso',
            }))
          }
        } catch (e) {
          setState(prev => ({ ...prev, loadingMessage: null, errorMessage: errorHandler(e) }))
        }
      },

      async onFileImported(content, mCicloid) {
        if (fileContent === null) {
          try {
            fileContent = content
            setState(prev => ({
              ...prev,
              loadingMessage: 'Realizando a importação . . .',
              clientesNaoCadastrados: [],
              produtosNaoCadastrados: [],
              rowsCaixaFracionadas: [],
              selectedTab: 0,
            }))

            const { type, payload } = await MultiDeliveryCycleHttp.importar(
              fileContent,
              mCicloid,
              userId,
            )
            const {
              clientes_nao_cadastrados,
              produtos_nao_cadastrados,
              tps_nao_cadastrados,
              rows_caixas_fracionadas,
              entregas_jah_importadas,
              ciclos,
            } = payload

            switch (type) {
              case 'cliente-nao-cadastrado':
                fileContent = null
                setState(prev => {
                  prev.loadingMessage = null
                  prev.errorMessage = 'Existe Cliente NÃO cadastrado'
                  prev.clientesNaoCadastrados = clientes_nao_cadastrados
                  prev.produtosNaoCadastrados = []
                  prev.selectedTab = 1
                  return { ...prev }
                })
                break
              case 'produto-nao-cadastrado':
                fileContent = null
                setState(prev => {
                  prev.loadingMessage = null
                  prev.errorMessage = 'Existe Produto NÃO cadastrado'
                  prev.clientesNaoCadastrados = []
                  prev.produtosNaoCadastrados = produtos_nao_cadastrados
                  prev.selectedTab = 2
                  return { ...prev }
                })
                break
              case 'tp-nao-cadastrado':
                fileContent = null
                setState(prev => {
                  const tpList = tps_nao_cadastrados.join(',')
                  const msg = `Os seguintes Tps não existem OU não estão associados a este usuário: ${tpList}`
                  prev.loadingMessage = null
                  prev.errorMessage = msg
                  prev.clientesNaoCadastrados = []
                  prev.produtosNaoCadastrados = []
                  prev.selectedTab = 0
                  return { ...prev }
                })
                break
              case 'existe-caixa-fracionada':
                fileContent = null
                setState(prev => {
                  prev.loadingMessage = null
                  prev.errorMessage = 'Existem caixas com quantidade fracionada'
                  prev.clientesNaoCadastrados = []
                  prev.produtosNaoCadastrados = []
                  prev.rowsCaixaFracionadas = rows_caixas_fracionadas
                  prev.selectedTab = 3
                  return { ...prev }
                })
                break
              case 'entregas-jah-importada':
                fileContent = null
                setState(prev => {
                  const identifiers = entregas_jah_importadas.map(e => e.identifier).join(',')
                  prev.loadingMessage = null
                  prev.errorMessage = `As seguintes entregas já foram importadas:${identifiers}`
                  prev.clientesNaoCadastrados = []
                  prev.produtosNaoCadastrados = []
                  prev.rowsCaixaFracionadas = []
                  prev.selectedTab = 0
                  return { ...prev }
                })
                break
              case 'ciclos_gerados':
                fileContent = null
                setState(prev => {
                  prev.loadingMessage = null
                  prev.errorMessage = null
                  prev.clientesNaoCadastrados = []
                  prev.produtosNaoCadastrados = []
                  prev.rowsCaixaFracionadas = []
                  prev.ciclos = ciclos
                  prev.selectedTab = 0
                  return { ...prev }
                })
                break
              default:
                break
            }
          } catch (e) {
            fileContent = null
            setState(prev => ({ ...prev, loadingMessage: null, errorMessage: errorHandler(e) }))
          }
        }
      },

      resetState() {
        setState(prev => ({ ...prev, errorMessage: null, successMessage: null }))
      },

      onModalClienteResponse(type, payload) {
        switch (type) {
          case 'success':
            setState(prev => {
              prev.clientesNaoCadastrados = prev.clientesNaoCadastrados.filter(
                c => c.code !== payload.company_code,
              )
              if (prev.clientesNaoCadastrados.length === 0) {
                prev.selectedTab = 0
              }
              prev.showModalCliente = false
              return { ...prev }
            })
            break
          case 'error':
            setState(prev => ({ ...prev, showModalCliente: false, errorMessage: payload }))
            break
          case 'close':
            setState(prev => ({ ...prev, showModalCliente: false }))
            break
          default:
            break
        }
      },

      onModalProdutoResponse(type, payload) {
        switch (type) {
          case 'success':
            setState(prev => {
              prev.produtosNaoCadastrados = prev.produtosNaoCadastrados.filter(
                c => c.code !== payload.product_code,
              )
              if (prev.produtosNaoCadastrados.length === 0) {
                prev.selectedTab = 0
              }
              prev.showModalProduto = false
              return { ...prev }
            })
            break
          case 'error':
            setState(prev => ({ ...prev, errorMessage: payload }))
            break
          case 'close':
            setState(prev => ({ ...prev, showModalProduto: false }))
            break
          default:
            break
        }
      },

      onDataOperacaoChange(value, item) {
        setState(prevState => {
          const index = prevState.ciclos.findIndex(
            c => c.delivery_cycle_id === item.delivery_cycle_id,
          )
          prevState.ciclos[index].data_operacao = value
          return { ...prevState }
        })
      },

      openModalCliente(cliente) {
        const { code, fantasia } = cliente
        setState(prev => ({
          ...prev,
          showModalCliente: true,
          selectedCliente: {
            company_code: code,
            nomeFantasia: fantasia,
            razaoSocial: fantasia,
            cnpj: '',
            city: '',
            address: '',
            district: '',
            number: '',
            makeParcialReturn: true,
            actived: true,
          },
        }))
      },

      openModalProduto(produto) {
        const { code, name } = produto
        setState(prev => ({
          ...prev,
          showModalProduto: true,
          selectedProduto: {
            product_code: code,
            company_id: 6, // Processo somente homologado para Danone
            name,
            weight: '',
            weight_liquido: '',
            unit_sku: '',
            m3: '',
            actived: true,
            ordem_separacao: '',
            caixa_com_peso_variavel: false,
            grupo: '', // Object
            qte_por_pallet: '',
            dias_para_vencimento: '',
            ean: '',
          },
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
